import type SvgProps from '~/components/icons/svg-props'

export default function CloseIcon(props: SvgProps) {
  return (
    <svg
      width={props.width}
      height={props.height}
      className={props.className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_6152_1066"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_6152_1066)">
        <path
          d="M12 13.0538L6.92701 18.127C6.78851 18.2653 6.61443 18.3362 6.40476 18.3395C6.19526 18.3427 6.01801 18.2718 5.87301 18.127C5.72818 17.982 5.65576 17.8063 5.65576 17.6C5.65576 17.3937 5.72818 17.218 5.87301 17.073L10.9463 12L5.87301 6.92701C5.73468 6.78851 5.66385 6.61443 5.66051 6.40476C5.65735 6.19526 5.72818 6.01801 5.87301 5.87301C6.01801 5.72818 6.19368 5.65576 6.40001 5.65576C6.60635 5.65576 6.78201 5.72818 6.92701 5.87301L12 10.9463L17.073 5.87301C17.2115 5.73468 17.3856 5.66385 17.5953 5.66051C17.8048 5.65735 17.982 5.72818 18.127 5.87301C18.2718 6.01801 18.3443 6.19368 18.3443 6.40001C18.3443 6.60635 18.2718 6.78201 18.127 6.92701L13.0538 12L18.127 17.073C18.2653 17.2115 18.3362 17.3856 18.3395 17.5953C18.3427 17.8048 18.2718 17.982 18.127 18.127C17.982 18.2718 17.8063 18.3443 17.6 18.3443C17.3937 18.3443 17.218 18.2718 17.073 18.127L12 13.0538Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
